export default "__VITE_ASSET__DZJ9A28y__"